import { gql } from "graphql-request";
import type { EventTimelineData, TimelineEvent, TimelineProtectedEvent } from "@nexus/widgets";

export const EVENT_TIMELINE_QUERY = gql`
  query EventTimeline(
    $from_ts: String
    $to_ts: String
    $tenant_ids: [Int!]
    $channel: String
    $event_id: String
    $limit: Int
  ) {
    event_timeline(
      from_ts: $from_ts
      to_ts: $to_ts
      tenant_ids: $tenant_ids
      channel: $channel
      event_id: $event_id
      limit: $limit
    ) {
      event_id
      event_label
      event_type
      event_start
      event_end
      unresolved_anomaly_count
      tenant_ids
      channels
      protected_events {
        protected_event_id
        tenant_id
        tenant_label
        channel
        rightholder
        unresolved_anomaly_count
      }
    }
  }
`;

export interface EventTimelineResponse {
  event_timeline: Array<{
    event_id: string;
    event_label: string;
    event_type: string;
    event_start: string;
    event_end: string;
    unresolved_anomaly_count: number;
    tenant_ids: string[];
    channels: string[];
    protected_events: Array<{
      protected_event_id: string;
      tenant_id: string;
      tenant_label: string;
      channel: string;
      rightholder: string;
      unresolved_anomaly_count: number;
    }>;
  }>;
}

export function normalizeEventTimeline(raw: unknown): EventTimelineData {
  const data = raw as EventTimelineResponse;
  return {
    events: (data.event_timeline ?? []).map((event): TimelineEvent => ({
      event_id: String(event.event_id),
      event_label: event.event_label,
      event_type: event.event_type,
      event_start: event.event_start,
      event_end: event.event_end,
      unresolved_anomaly_count: Number(event.unresolved_anomaly_count),
      tenant_ids: (event.tenant_ids ?? []).map(String),
      channels: event.channels ?? [],
      protected_events: (event.protected_events ?? []).map((item): TimelineProtectedEvent => ({
        protected_event_id: String(item.protected_event_id),
        tenant_id: String(item.tenant_id),
        tenant_label: item.tenant_label,
        channel: item.channel,
        rightholder: item.rightholder,
        unresolved_anomaly_count: Number(item.unresolved_anomaly_count),
      })),
    })),
  };
}
